import React from 'react';
import { Category, Subcategory } from '../../../types';
import { SubcategoryPicker } from './SubcategoryPicker';
import styled from 'styled-components';
import {
  FormGroup,
  FormSelect,
  FormHelpText,
  IconClear,
  ButtonIcon,
} from '@spotify-internal/encore-creator-web';

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledButtonIcon = styled(ButtonIcon)`
  margin-left: 16px;
`;
interface Props {
  categories: Category[];
  selectedCategory: Category;
  onChangeCategory(category: Category): void;
  selectedSubcategories: Set<Subcategory>;
  onRemove?(): void;
  label: string;
  id: string;
  required?: boolean;
}

export function CategoryPicker(props: Props) {
  function handleSelectCategory(event: React.ChangeEvent<HTMLSelectElement>) {
    const category = {
      ...props.categories.find(cat => cat.value === event.target.value)!,
      subcategories: [],
    };

    props.onChangeCategory(category);
  }

  function handleSelectSubcategories(subcategories: Set<Subcategory>) {
    const category = {
      ...props.selectedCategory,
      subcategories: Array.from(subcategories),
    };
    props.onChangeCategory(category);
  }

  const allSubcatagories = props.categories.find(cat => cat.value === props.selectedCategory.value)!
    .subcategories;

  return (
    <>
      <FormGroup
        label={props.label}
        labelFor={props.id}
        indicator={props.required ? 'required' : undefined}
      >
        <InputContainer>
          <FormSelect
            data-testid={`primary-picker-${props.selectedCategory.value}`}
            onChange={handleSelectCategory}
            value={props.selectedCategory.value}
            id={props.id}
          >
            <option value="" disabled>
              Select category
            </option>
            {props.categories.map(category => (
              <option key={category.value} value={category.value}>
                {category.name}
              </option>
            ))}
          </FormSelect>
          {props.onRemove ? (
            <StyledButtonIcon
              onClick={props.onRemove}
              data-testid={`remove-category-${props.selectedCategory.value}`}
            >
              <IconClear aria-label="IconClear" iconSize={24} />
            </StyledButtonIcon>
          ) : null}
        </InputContainer>
      </FormGroup>
      <FormGroup label={`Choose up to 3 sub-categories of ${props.selectedCategory.name}`}>
        <SubcategoryPicker
          subcategories={allSubcatagories}
          value={props.selectedSubcategories}
          onSelect={handleSelectSubcategories}
        />
      </FormGroup>
    </>
  );
}
